module.exports = __webpack_public_path__ + "img/MADNESS.3cc6ac65.png";